import { jsx } from "react/jsx-runtime";
import { Box, TextButton } from "@zillow/constellation";
import { yieldCallback } from "@zillow/yield-callback";
import "react";
import { getCmsInfoForPage } from "../../utils/clickstream/getCmsInfoForPage.esm.js";
import { sendEvent } from "./B2BUserNav.utils.esm.js";
import { usePageProps } from "@zillow/cms-utils";
const TextButtonAnchor = (props) => /* @__PURE__ */ jsx(TextButton, { as: "a", fontType: "bodySmall", ...props });
const SignOut = ({
  dropdown,
  url,
  userMenuItems
}) => {
  const pageProps = usePageProps();
  const cmsInfo = getCmsInfoForPage(pageProps);
  const menuItems = [...userMenuItems || [], {
    label: "Sign out",
    url
  }];
  return /* @__PURE__ */ jsx(Box, { as: "ul", "aria-expanded": dropdown, sx: {
    position: "absolute",
    display: dropdown ? "block" : "none",
    ariaEpanded: dropdown ? "true" : "false",
    top: "calc(100% + 4px)",
    right: "calc($spacing.xs * -1)",
    margin: 0,
    minWidth: "calc($spacing.md * 5)",
    padding: 0,
    backgroundColor: "$colors.backgroundWhite",
    borderRadius: "$radii.md",
    boxShadow: "$shadows.shadow200",
    fontSize: "$fontSizes.body",
    fontWeight: "$fontWeights.body",
    zIndex: "$zIndices.popover",
    overflow: "hidden"
  }, children: menuItems.map((item) => /* @__PURE__ */ jsx(Box, { as: "li", sx: {
    padding: "$spacing.xxs $spacing.sm",
    listStyle: "none",
    ":hover": {
      backgroundColor: "$colors.backgroundBlue"
    }
  }, children: /* @__PURE__ */ jsx(TextButtonAnchor, { href: item.url, onClick: yieldCallback(() => {
    sendEvent("cms_anchor", item.label, item.url, cmsInfo);
  }), children: item.label }) }, item.label)) });
};
export {
  SignOut as default
};
